export default __webpack_public_path__ + "static/media/dashboard.ac643ad8.webp";